import styled from 'styled-components'
import NextImage from 'next/image'

import Link from '../Link'
import Icon from '../Icon'

export const RetailerCard = styled(Link)`
  width: 100%;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.greyContour};
  border-radius: 2rem;
  padding: 3rem 2rem 1rem;
`

export const RetailerCardImage = styled(NextImage)`
  display: block;
  margin: 0 auto 2.5rem auto;
`

export const RetailerCardCategory = styled.h4`
  ${({ theme }) => theme.textStyles.bebasXs};
  color: ${({ theme }) => theme.colors.taupeGray};
  margin: 1rem 0;
  text-transform: uppercase;
`

export const RetailerCardWebSiteLink = styled(Link)`
  ${({ theme }) => theme.textStyles.firaSansXl};
  color: ${({ theme }) => theme.colors.bluePrimary};
  font-weight: 600;
`

export const RetailerCardDescription = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.taupeGray};
  margin-top: 2rem;
`
export const RetailerCardOtherOffersBlock = styled.div`
  margin-top: 3rem;
  border-top: 2px solid ${({ theme }) => theme.colors.blueLight};
  padding-top: 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const RetailerCardOtherOffers = styled.span``

export const RetailerCardNumberOffers = styled.span`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.pinkButton};
  margin-right: 0.6rem;
`

export const RetailerCardMinPrice = styled.span`
  ${({ theme }) => theme.textStyles.montserratXs};
  color: ${({ theme }) => theme.colors.pinkButton};
`

export const RetailerCardOtherOffersLink = styled(Link)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  &:hover {
    svg {
      transform: translateX(5px);
    }
  }
`

export const ArrowRight = styled(Icon)`
  color: ${({ theme }) => theme.colors.pinkButton};
  transition: transform 320ms ease-in-out;
`
